import { createRouter, createWebHistory } from 'vue-router'
import Landing from './components/Landing.vue'
import Generate from './components/Generate.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Landing
  },
  {
    path: '/generate',
    name: 'generate',
    component: Generate
  },
  {
    path: '/generate/:id',
    name: 'generate-session',
    component: Generate,
    props: (route) => ({ sessionId: route.params.id })
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
